import 'css-chunksrc/client/pages/projectPage/resourcesPage/menu/styles.scss';export default {
  "menu": "_menu_2x39i_1",
  "addResourceButton": "_addResourceButton_2x39i_5",
  "icon": "_icon_2x39i_25",
  "iconBox": "_iconBox_2x39i_33",
  "list": "_list_2x39i_42",
  "item": "_item_2x39i_57",
  "name": "_name_2x39i_71"
};